export const ultimasNoticias = [
    
   //   {
   //      "imagen" : "assets/imgs/comisionpermanente.jpeg",

   //      "url" : "https://www.facebook.com/photo.php?fbid=1141667654661088&set=pb.100064535929070.-2207520000&type=3&locale=es_LA",
   //      "titulo" : "Contralores México",
       
   //     "fecha" : "Contralores México",
   //   }, 
   //   {
   //      "imagen" : "assets/imgs/CONTRALORIASOCIAL12.jpg",

   //      "url" : "https://www.facebook.com/share/p/1F7xuoj15B/",
   //      "titulo" : "Premio Nacional de Contralores ",
       
   //     "fecha" : "Contraloría Social",
   //   }, 


   //   {
   //      "imagen" : "assets/imgs/convocsatorias (2).jpg",
   //      "url" : "https://s-contraloria.hidalgo.gob.mx/interes/Convocatoria-Transparencia-en-Corto-2025.pdf",

   //      "titulo" : "Premio Nacional de Contralores ",
   //       "fecha" : "Contraloría Social",
   //  }, 

 
    {
        "imagen" : "assets/imgs/ceuhm.jpg",
        "url" : "https://www.facebook.com/share/p/1DY8Yqtd93/",
        "titulo" : "Secretaría de Contraloría Hidalgo",
        "fecha" : "La Contraloría participó en una jornada de capacitación del Centro Universitario Metropolitano Hidalgo - CEUMH",
    },

     {
        "imagen" : "assets/imgs/requisitos.jpg",
        "url" : "https://www.facebook.com/share/p/1CwVfwVvpE/",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Tu historia puede generar conciencia.",
    },
     {
        "imagen" : "assets/imgs/unizimapan.jpg",
        "url" : "https://www.facebook.com/share/p/1MmHvByAN",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Concluimos el proceso de auditoría en la Universidad Tecnológica Minera de Zimapán.",
    }, 

    
    {
        "imagen" : "assets/imgs/tecmorelos.jpg",
        "url" : "https://www.facebook.com/share/p/1ALTKX8qWR",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Participación en la Primera Feria de las Tecnologías de la Comisión Permanente de Contralores Estados-Federación Contralorías Mx.",
    },     


  
    {
        "imagen" : "assets/imgs/partimorelos.jpg",
         "url" : "https://www.facebook.com/share/p/1BEHDNafE9",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "https://x.com/Contraloria_Hgo/status/2080828913324823039?ref_src=twsrc%5Etfw%7Ctwcamp%5Etweetembed%7Ctwterm%5E2080828913324823039%7Ctwgr%5E%7Ctwcon%5Es1_&ref_url=about%3Asrcdoc.",
    },



   
 {
        "imagen" : "assets/imgs/xochiatipan.jpg",
         "url" : "https://www.facebook.com/share/p/1BFS2Wb1FY",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Directora General Briseyda Torres, acudió a #Xochiatipan como parte de las Brigadas Transformación",
    },

 
 
 
    // {
    //     "imagen" : "noticias/comision.gif",
    //      "url" : "https://comisioncontralores.gob.mx/2023/",
    //     "titulo" : "Comisión Permanente de Contralores ",
    //    "fecha" : "Estados-Federación",
    // },     

    // {
    //     "imagen" : "noticias/9_jornada.jpg",
    //      "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/1141123597339219/?mibextid=rS40aB7S9Ucbxw6v",
    //     "titulo" : "9 JORNADA DE CAPACITACIÓN ",
    //    "fecha" : "PARA LA TRANSFORMACIÓN DE HIDALGO",
    // },
    // {
    //     "imagen" : "noticias/convenio.jpg",
    //     "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/1156571106119065",
    //     "titulo" : "Firma de Convenio de Donación de Sistemas por la Secretaría de la Honestidad ",
    //     "fecha" : "y la Secretaría de Contraloría de Hidalgo."
    // },
   


    // {
    //     "imagen" : "noticias/2da sesion.png",
    //     "url" : "https://www.facebook.com/share/p/14qTV3iovd/?mibextid=WC7FNe",
    //     "titulo" : " Segunda Asamblea Plenaria de la Comisión Permanente de Contralores Estado-Municipios",
    //     "fecha" : "28 de noviembre del 2024"
    // },



]